import { SYNC_LIMIT_LOW } from '@/utilities/constants';

import { create } from '../replication-v2/FamilyMember/create';
import { FamilyMember } from '../replication-v2/FamilyMember/FamilyMember';
import { ConfigBuilder, doNotAutoSync, pull, replicate } from '../replication-v2/replicate';
import { RxdbCollectionNameV2 } from '../replication-v2/RxdbCollectionNameV2';
import { CuttingMethodDocument, cuttingMethodPullQueryBuilder } from './queryBuilder';

export function cuttingMethodFamilyMember(
  configBuilder: ConfigBuilder,
  sites: FamilyMember,
): FamilyMember {
  const syncConfig = configBuilder<CuttingMethodDocument>(RxdbCollectionNameV2.CUTTING_METHOD);
  doNotAutoSync(syncConfig);

  const pullConfig = pull(syncConfig, cuttingMethodPullQueryBuilder);
  pullConfig.batchSize = SYNC_LIMIT_LOW;

  const replicationState = replicate(syncConfig);
  // Legacy set the syncInterval to LiveInterval.MINUTES_30.
  return create(RxdbCollectionNameV2.CUTTING_METHOD, replicationState, [sites]);
}
